import { render } from "./KoyuTable.vue?vue&type=template&id=3645b934&scoped=true"
import script from "./KoyuTable.vue?vue&type=script&lang=js"
export * from "./KoyuTable.vue?vue&type=script&lang=js"

import "./KoyuTable.vue?vue&type=style&index=0&id=3645b934&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3645b934"]])

export default __exports__